import { render, staticRenderFns } from "./CollectPaymentModal.vue?vue&type=template&id=42cc629a"
import script from "./CollectPaymentModal.vue?vue&type=script&lang=js"
export * from "./CollectPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./CollectPaymentModal.vue?vue&type=style&index=0&id=42cc629a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports